import gql from 'graphql-tag';

import { courseFragment } from '~/shared/graphql-queries/courses/index';

export const findOneCourseQueryRequest = `
  query findOneCourseQuery($filter: FilterFindOneCourseInput!) {
    findOneCourseQuery(filter: $filter) {
      _id
      alias
      language
      isPublished
      metaTitle
      metaDescription
      image {
        path
      }
    }
  }
`;

export default gql`
  query findOneCourseQuery($alias: String!, $isFreeCourse: Boolean) {
    findOneCourseQuery(filter: { alias: $alias, isFreeCourse: $isFreeCourse }) {
      ...CourseFragment
    }
  }
  ${courseFragment}
`;
